// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ow-6";
export var imgContainer = "_ow-3";
export var menuIcon = "_ow-5";
export var pillWrapper = "_ow-2";
export var pillsContainer = "_ow-1";
export var subscriptionCard = "_ow-0";
export var subscriptionLogo = "_ow-4";